import { useMutation } from '@tanstack/react-query';
import { type BulkValidateRequest, type BulkValidateResponse, validateBulkFilter } from '../../lib/api/bulkFilter';

export function useValidateBulkFilterMutation() {
  const mutation = useMutation<BulkValidateResponse, unknown, BulkValidateRequest>({
    mutationFn: validateBulkFilter,
    mutationKey: ['validateBulkFilter'],
  });
  return {
    ...mutation,
    trigger: mutation.mutateAsync,
    isLoading: mutation.isPending,
  };
}
